import mixpanel from 'mixpanel-browser'

const track = (where, title, params) => {
  return mixpanel.track(`Ação em ${where}: ${title}`, params)
}

export default track
